@let user = userStateService.currentUser();
@let isEditing = userStateService.navbarButtonState() === 'EDIT';
@if (user) {
  <div [formGroup]="form" class="flex gap-10 p-4">
    <div>
      <img class="h-64 w-64 object-contain" [src]="user.cover?.url">
    </div>
    <div class="flex gap-4">
      <div class="flex flex-col w-96">
        <div class="gap-2 flex">
          <div>
            Nome
            <input wunInput [readOnly]="!isEditing" class="!font-bold" formControlName="firstName">
          </div>
          <div>
            Cognome
            <input wunInput [readOnly]="!isEditing" class="!font-bold" formControlName="lastName">
          </div>
        </div>
        <div class="flex flex-col">
          <p>
            Email
            <input wunInput [readOnly]="!isEditing" formControlName="email">
          </p>
          <p>
            Paese
            <input wunInput [readOnly]="!isEditing" formControlName="country">
          </p>
          <p>
            Cittá
            <input wunInput [readOnly]="!isEditing" formControlName="city">
          </p>
          <p>
            Telefono
            <input wunInput [readOnly]="!isEditing" formControlName="phone">
          </p>
          @if (user.profileType === 'ARTIST') {
            <p>
              Codice Galleria Assegnata
              <input wunInput [readOnly]="!isEditing" formControlName="assignedToGallery" placeholder="Inserisci codice galleria">
            </p>
          }
        </div>
      </div>
      <div class="items-end flex gap-4">
        <div>
          <div class="font-bold">Autore di blog</div>
          <wun-toggle formControlName="blogAuthorEnabled" label="" [options]="blogOptions"></wun-toggle>
        </div>
        <div class="flex flex-col gap-2">
          <div class="font-bold">Data di registrazione</div>
          <div>
            {{ user.createdAt | date : 'dd-MM-yyyy' }}
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="font-bold">Stato</div>
          @if (isEditing) {
            <div>
              <select [disabled]="!isEditing" formControlName="status">
                <option ngValue="ACTIVE">ACTIVE</option>
                <option ngValue="DISABLED">DISABLED</option>
              </select>
            </div>

          } @else {
            <div>
              {{ user.status }}
            </div>
          }

        </div>
      </div>
    </div>

  </div>
}

